import { useParams } from 'react-router-dom'

import { FormApp, FormControl, InputApp, ModalApp, Spinner, TextAreaInput } from '@/components'
import { Param } from '@/models/params'

import { CreateAndEditIndexModalProps } from '../data/types'
import { useCreateAndEditIndexModal, useSellTreezIndexMapping } from '../hooks'

export const CreateAndEditIndexModal = ({
  isOpenModal,
  handleCloseModal,
  index,
  handleSubmitIndex,
  isSubmitting,
}: CreateAndEditIndexModalProps) => {
  const { sellTreezId } = useParams<Param>()

  const { mappings, isLoading } = useSellTreezIndexMapping({
    sellTreezId: sellTreezId as string,
    indexName: index?.index as string,
  })

  const { register, handleSubmit, errors } = useCreateAndEditIndexModal({
    index,
    mappings,
  })

  return (
    <ModalApp
      isOpenModal={isOpenModal}
      handleCloseModal={handleCloseModal}
      title={index ? 'Edit Mappings' : 'Create Index'}
      maxHeight="xs:max-h-[820px] md:max-h-[800px]"
      maxWidth="xs:max-w-[340px] md:max-w-lg"
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <FormApp
          handleCancel={handleCloseModal}
          handleSubmit={handleSubmit}
          onSubmit={handleSubmitIndex}
          textButton={index ? 'Save' : 'Create'}
          isSubmitting={isSubmitting}
        >
          <div className="flex flex-col gap-6">
            <FormControl label="Name" isRequired messageError={errors.index?.message}>
              <InputApp
                name="index"
                placeholder="Name"
                register={register}
                isError={!!errors.index?.message}
                disabled={!!index}
              />
            </FormControl>
            <FormControl
              label="Mappings"
              isRequired
              messageError={errors.body?.properties?.message}
            >
              <TextAreaInput
                rows={10}
                name="body.properties"
                placeholder="Enter mappings"
                register={register}
                isError={!!errors.body?.properties?.message}
              />
            </FormControl>
          </div>
        </FormApp>
      )}
    </ModalApp>
  )
}
